export default __webpack_public_path__ + "static/media/signupresource.48f6d5bc.svg";